// Per-account, per-version persistence of the dashboard chat's active
// conversation id. The version prefix matches the convention used by
// useTimerState so the schema can evolve without colliding with old entries.
const KEY_PREFIX = 'bill_dashboardChat_v1_conversationId_';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function storageKey(accountId: string): string {
  return KEY_PREFIX + accountId;
}

export function readConversationId(accountId: string): string | null {
  const value = localStorage.getItem(storageKey(accountId));
  if (!value) return null;
  // Guard against malformed entries (manual tampering, browser-extension
  // injection). The backend rejects unknown ids with 403/404, so the worst
  // case is wasted requests; evict the bad entry so we stop refetching.
  if (!UUID_RE.test(value)) {
    localStorage.removeItem(storageKey(accountId));
    return null;
  }
  return value;
}

export function writeConversationId(accountId: string, conversationId: string): void {
  // Reject malformed values at source rather than catching them on next read.
  // Both current callers pass server-origin UUIDs, but enforcing the guard
  // symmetrically prevents a future caller from corrupting localStorage.
  if (!UUID_RE.test(conversationId)) return;
  localStorage.setItem(storageKey(accountId), conversationId);
}

export function clearConversationId(accountId: string): void {
  localStorage.removeItem(storageKey(accountId));
}

export function clearAllDashboardChatPersistence(): void {
  // Collect first, then remove - mutating localStorage during a length-based
  // loop shifts indices and skips entries.
  const keys: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (k && k.startsWith(KEY_PREFIX)) keys.push(k);
  }
  for (const k of keys) localStorage.removeItem(k);
}
